import { withResult } from 'feathers-fletching';
import { disallow } from 'feathers-hooks-common';
import { withSearch } from 'src/feathers/hooks';
import {
  DOCUMENT_TYPE,
  statusType,
  truckType
} from 'straightline-utils/constants';

const withSearches = withSearch({
  'pickup_address.city': withSearch.string,
  'pickup_address.name': withSearch.string,
  'delivery_address.city': withSearch.string,
  'delivery_address.name': withSearch.string,
  '$shipper.name$': withSearch.string,
  reference_number: withSearch.text,
  id: withSearch.number
});

const withResults = withResult({
  status: (shipment) => {
    if (shipment.status_type) {
      return statusType(shipment.status_type);
    }
  },
  truck: (shipment) => {
    if (shipment.truck_type) {
      return truckType(shipment.truck_type);
    }
  },
  pickup_address: (shipment) => {
    if (shipment.pickup_address) {
      return {
        ...shipment.pickup_address,
        position: {
          lat: Number(shipment.pickup_address.latitude),
          lng: Number(shipment.pickup_address.longitude)
        }
      };
    }
  },
  delivery_address: (shipment) => {
    if (shipment.delivery_address) {
      return {
        ...shipment.delivery_address,
        position: {
          lat: Number(shipment.delivery_address.latitude),
          lng: Number(shipment.delivery_address.longitude)
        }
      };
    }
  },
  pod: async (shipment, context) => {
    if (!context.params.$include?.includes('pod')) {
      return undefined;
    }

    const pod = await context.app.service('api/shipment-documents').findOne({
      query: {
        $sort: { created_at: -1 },
        shipment_id: shipment.id,
        '$document.document_type$': DOCUMENT_TYPE.PROOF_OF_DELIVERY
      }
    });

    return pod || null;
  }
});

export default {
  before: {
    all: [withSearches],
    find: [],
    get: [],
    create: [disallow()],
    update: [disallow()],
    patch: [],
    remove: [disallow()]
  },
  after: {
    all: [withResults],
    find: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
